import axios from "../../js/project-axios.js"

const list = (keyword, categoryId, locationId, state, pageSize, pageNumber) => {
    return axios.get("/asset/asset/list", {
        params: {
            keyword,
            categoryId,
            locationId,
            state,
            pageSize,
            pageNumber
        }
    });
};

const get = id => {
    return axios.get("/asset/asset/get", {
        params: {
            id
        }
    });
};

const listDepreciation = batchId => {
    return axios.get("/asset/asset/listDepreciation", {
        params: {
            batchId
        }
    });
};

const add = asset => {
    return axios.post("/asset/asset/add", asset);
};

const update = asset => {
    return axios.post("/asset/asset/update", asset);
};

const remove = asset => {
    return axios.post("/asset/asset/remove", asset);
};

const addBatch = batch => {
    return axios.post("/asset/asset/addBatch", batch);
};

const splitBatch = (batchId, splitQuantity) => {
    return axios.post("/asset/asset/splitBatch", {
        batchId,
        splitQuantity
    });
};

const depreciateBatch = (batchId, depreciateQuantity, depreciateValue) => {
    return axios.post("/asset/asset/depreciateBatch", {
        batchId,
        depreciateQuantity,
        depreciateValue
    });
};

const changeState = (batchId, state) => {
    return axios.post("/asset/asset/changeState", {
        batchId,
        state
    });
};

export default {
    list,
    get,
    listDepreciation,
    add,
    update,
    remove,
    addBatch,
    splitBatch,
    depreciateBatch,
    changeState
};